import { toJS } from 'mobx'
import * as d3 from 'd3'
import lodash from 'lodash'

/**
 * 布局数据
 */
export const makeLayoutData = (rootNodeId: string, nodes: any, links: any, showType: string) => {
  //   nodes = JSON.parse(JSON.stringify(toJS(nodes)))
  nodes = lodash.cloneDeep(toJS(nodes))

  let layout_nodes

  switch (showType) {
    case 'lattice':
      layout_nodes = latticeLayout(nodes)
      break
    case 'tree':
      layout_nodes = treeFactory(nodes)
      break
    case 'circle':
      layout_nodes = circleFactory(rootNodeId, nodes, links)
      break
    default:
      layout_nodes = nodes
  }
  return layout_nodes.map((n: any) => {
    return { id: n.id, x: n.fx, y: n.fy }
  })
}

const circleFactory = (rootNodeId: string, nodes: any, links: any) => {
  // 数据转换成树
  const tree_data = dataToTree(rootNodeId, nodes, links)
  if (!tree_data) { return nodes }
  // 数据生成布局（点坐标）
  const tree_nodes = treeLayout(tree_data)
  // 转换成圆坐标
  const cricle_nodes = circleNodes(tree_nodes)
  // // 锁定点坐标
  return treeNodes(nodes, cricle_nodes)
}

/**
 * 节点数据转换成树结构数据
 * @param {根节点ID} node_0_id
 * @param {节点列表} nodes
 * @param {节点关系} links
 */
export const dataToTree = (node_0_id: string, _nodes: any, _links: any, two_tree: boolean = true) => {
  const nodes: any = toJS(_nodes)
  const links: any = toJS(_links)

  // tslint:disable-next-line:one-variable-per-declaration
  const nodes_obj: any = {}, links_obj: any = {}

  // 整理节点和link数据
  nodes.map((item: any) => Object.assign(nodes_obj, { [item.id]: item }))
  const getLink = (arr: any) => {
    arr.forEach((item: any) => {
      if (!links_obj[item.source]) {
        links_obj[item.source] = []
      }
      if (!links_obj[item.target]) {
        links_obj[item.target] = []
      }
      links_obj[item.target].push({
        source: item.target,
        target: item.source,
      })
      links_obj[item.source].push({
        source: item.source,
        target: item.target,
      })
    })
  }
  getLink(links)

  /**
   * 创建节点树
   * @param {*} node_id 根节点ID
   * @param {*} remove 在子节点不存在时是否移除根节点
   */
  const createTreeNodes = (node: any, remove = true) => {
    if (!node) {
      return null
    }
    const id = node.id
    const tree: any = Object.assign({}, node, {
      id: node.id,
      name: node.name,
      children: [],
    })
    if (links_obj[id]) {
      // 遍历根节点的link
      // tslint:disable-next-line: forin
      for (const link_i in links_obj[id]) {
        const link = links_obj[id][link_i]
        const end_node_id = link.target
        // 如目标节点没被使用 把节点加入到根节点的子节点中
        if (nodes_obj[end_node_id]) {
          // 移除使用过的link
          delete links_obj[id][link_i]
          tree.children.push(nodes_obj[end_node_id])
          delete nodes_obj[end_node_id]
        }
      }
    }
    for (let i = 0; i < tree.children.length;) {
      const new_children = createTreeNodes(tree.children[i])
      if (new_children) {
        tree.children[i] = new_children
        i++
      } else {
        tree.children.splice(i, 1)
      }
    }
    if (!remove && tree.children.length === 0) {
      // 如果存在子节点 根节点不再使用
      nodes_obj[id] = node
    }
    return tree
  }

  /**
   * 只有两层的树
   */
  const onChildrenTree: any = (node_id: any) => {
    const node = nodes_obj[node_id]
    if (!node) {
      return null
    }
    // 移除根节点
    delete nodes_obj[node_id]
    const id = node.id
    const tree: any = {
      id: node.id,
      name: node.name,
      children: [],
    }
    nodes.forEach((node: any) => {
      if (node.id === id) { return }
      tree.children.push({
        id: node.id,
        name: node.name,
        type: node.labels[0],
        children: [],
      })
    })
    return tree
  }

  // 返回两层的树
  if (two_tree) {
    // 返回两层的树
    return onChildrenTree(node_0_id)
  } else {
    const node = nodes_obj[node_0_id]
    delete nodes_obj[node_0_id]
    // 返回设定结点的树
    return createTreeNodes(node)
  }
}

/**
 * 树布局生成
 * @param {树结构数据} data
 * @returns 新的节点数据
 */
export const treeLayout = (data: any) => {
  const nodeR = 40
  const linkDistance = 300
  const tree = d3
    .tree()
    .size([2 * Math.PI, 200])
    .nodeSize([nodeR * 3, (nodeR * 2 + linkDistance) * 2])
  return tree(
    d3.hierarchy(data).sort((a: any, b: any) => {
      return a.data.type > b.data.type ? -1 : 1
    }),
  )
    .descendants()
    .reverse()
}

/**
 * 根据节点 和 节点位置坐标生成新的节点列表
 * @param {部分节点坐标} fix_nodes
 */
export const treeNodes = (nodes: any, fix_nodes: any) => {
  const obj_fix_nodes: any = {}
  fix_nodes.forEach((item: any) => {
    delete item.data.children
    obj_fix_nodes[item.data.id] = {
      fx: item.x,
      fy: item.y,
    }
  })

  const tree_nodes = []
  // tslint:disable-next-line: forin
  for (const i in nodes) {
    const id = nodes[i].id
    // tslint:disable-next-line: no-empty
    if (obj_fix_nodes[id]) {
    }
    tree_nodes.push(Object.assign(nodes[i], obj_fix_nodes[id]))
  }
  return tree_nodes
}

/**
 * 坐标换算成径向坐标
 * @param {*} tree_nodes
 */
export const circleNodes = (tree_nodes: any) => {
  let depth = 1
  let nodeR = 0
  let num = 0
  const length = tree_nodes.length
  if (length >= 10 && length <= 15) {
    nodeR = 80
    num = 3
  } else if (length > 6 && length < 10) {
    nodeR = 120
    num = 2
  } else if (length > 2 && length <= 6) {
    nodeR = 160
    num = 1.5
  } else if (length === 2) {
    nodeR = 480
    num = 0.5
  } else {
    nodeR = 40
    num = 6
  }
  // 计算小圆围成大圆的半径
  const y = (tree_nodes.length * nodeR * 1.5) / Math.PI
  tree_nodes.forEach((item: any) => {
    depth = item.depth > depth ? item.depth : depth
    if (item.parent) {
      const { x } = item
      let len = item.parent.children.length
      // 一层最少按照6个计算 没多加一层可以多加一倍
      len = len >= num * item.depth ? len : num * item.depth
      item.x =
        Math.cos(((x / 3 / nodeR / len) * 360 * (12.0 / num) * Math.PI) / 360) * y
      item.y =
        Math.sin(((x / 3 / nodeR / len) * 360 * (12.0 / num) * Math.PI) / 360) * y
    }
  })

  return tree_nodes
}

/**
 * 点阵布局生成
 */
export const latticeLayout = (nodes: any) => {
  const nodeR = 40
  const linkDistance = 300
  const len = nodes.length
  const row_len: any = Math.ceil(Math.sqrt(len))
  // 计算出会有多少层，然后算出起始坐标
  const start_val = -(
    (Math.ceil(len / row_len) * (nodeR * 2 + linkDistance)) / 2 -
    linkDistance
  )

  let row_i = 0
  let column_i = 0
  const new_nodes = nodes.map((item: any) => {
    item.fx = start_val + row_i * (nodeR * 2 + linkDistance)
    item.fy = start_val + column_i * (nodeR * 2 + linkDistance)
    row_i++
    if (row_i > row_len - 1) {
      row_i = 0
      column_i++
    }
    return item
  })
  return new_nodes
}

/**
 * 最多5个层级的伪树形图
 * @param nodes
 */
export const treeFactory = (nodes: any) => {
  const nodeR = 40
  const row_obj: any = {
    hkex: [],
    hkex_group: [],
    part_b: [],
    other: [],
  }

  const row_obj_position: any = {
    hkex: (index: number) => {
      // 第几行
      const row: any = parseInt((index / 3) + '', 10)
      // 第几列
      const rank: any = index % 3
      const linkDistance = nodeR * 3
      // 起始x坐标 起始y坐标
      const start_x: number = linkDistance
      const start_y: number = -2 * (nodeR * 2 + linkDistance)
      const x: number = start_x + (rank * nodeR * 2) + row * linkDistance
      const y: number = start_y + rank * linkDistance
      return {
        x, y,
      }
    },
    hkex_group: (index: number) => {
      // 第几行
      const row: any = parseInt((index / 3) + '', 10)
      // 第几列
      const rank: any = index % 3
      const linkDistance = nodeR * 3
      // 起始x坐标 起始y坐标
      const start_x: number = -2.5 * (nodeR * 2 + linkDistance)
      const start_y: number = 0 * (nodeR * 2 + linkDistance)
      const x: number = start_x + (rank * nodeR * 2) - row * linkDistance
      const y: number = start_y + rank * linkDistance
      return {
        x, y,
      }
    },
    part_b: (index: number) => {
      // 第几行
      const row: any = parseInt((index / 3) + '', 10)
      // 第几列
      const rank: any = index % 3
      const linkDistance = nodeR * 3
      // 起始x坐标 起始y坐标
      const start_x: number = 1 * (nodeR * 2 + linkDistance)
      const start_y: number = 1 * (nodeR * 2 + linkDistance)
      const x: number = start_x - (rank * nodeR * 2) + row * linkDistance
      const y: number = start_y + rank * linkDistance
      return {
        x, y,
      }
    },
    other: [],
  }

  // 统计各层级的点
  // 已经计算好的点属性
  nodes.forEach((node: any) => {
    const props = node.props
    const type = props.hkex ? 'hkex' : (props.hkex_group ? 'hkex_group' : 'part_b')
    switch (type) {
      case 'hkex': // HKEX
        row_obj['hkex'].push(node)
        break
      case 'hkex_group': // 甲方
        row_obj['hkex_group'].push(node)
        break
      case 'part_b': // 乙方
        row_obj['part_b'].push(node)
        break
      default:
        row_obj['other'].push(node)
    }
  })

  row_obj['hkex'].forEach((node: any, index: number) => {
    const { x, y } = row_obj_position.hkex(index)
    node.fx = x
    node.fy = y
  })

  row_obj['hkex_group'].forEach((node: any, index: number) => {
    const { x, y } = row_obj_position.hkex_group(index)
    node.fx = x
    node.fy = y
  })

  row_obj['part_b'].forEach((node: any, index: number) => {
    const { x, y } = row_obj_position.part_b(index)
    node.fx = x
    node.fy = y
  })

  return nodes
}
